import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { RawTeamPersonSessionData } from './types'

export const teamPersonSessionsAdapter =
  createEntityAdapter<RawTeamPersonSessionData>()

export const initialTeamPersonSessionsState =
  teamPersonSessionsAdapter.getInitialState({
    selectedTeamId: null
  })

export const teamPersonSessionsSlice = createSlice({
  name: 'teamPersonSessions',
  initialState: initialTeamPersonSessionsState,
  reducers: {
    upsertOne: teamPersonSessionsAdapter.upsertOne,
    upsertMany: teamPersonSessionsAdapter.upsertMany,
    removeOne: teamPersonSessionsAdapter.removeOne,
    removeAll: teamPersonSessionsAdapter.removeAll
  }
})

export const reducer = teamPersonSessionsSlice.reducer

export const {
  upsertOne: upsertOneTeamPersonSession,
  upsertMany: upsertManyTeamPersonSessions,
  removeOne: removeOneTeamPersonSession,
  removeAll: removeAllTeamPersonSessions
} = teamPersonSessionsSlice.actions
